import React, { Fragment, useState, useCallback } from 'react';
import { InputSearch } from './inputSearch';
import MultiSelect from './multi-select';
import './index.scss';

interface IDropDown {
  key: string;
  displayName: string;
  helpText?: string;
}

type Props = {
  optionsList: Array<IDropDown>;
  label: string;
  searchLabel: string;
  onChange: () => {};
  disabled?: boolean;
  selectedOption: Array<IDropDown>;
  setSelectedOption: (value: Array<IDropDown>) => {};
};

export const MultiSelectDropDownWithSearch: React.FC<Props> = ({
  optionsList = [],
  label = '',
  searchLabel = '',
  onChange = () => {},
  disabled = false,
  selectedOption,
  setSelectedOption
}) => {
  const [options, setOptions] = useState(() => optionsList);

  const onSearchChange = (value: string) => {
    const filteredOptions = optionsList.filter((option) => (value ? option?.displayName?.toLowerCase().includes(value.toLowerCase()) : true));
    setOptions(filteredOptions);
  };

  const renderSearch = () => {
    return (
      <div className="input_with_search">
        <InputSearch label={searchLabel} value="" onChange={onSearchChange} placeholder="Search Email Id" />
        <i className="aeh-icon-outlined-search-icon"></i>
      </div>
    );
  };

  const crossIconHandler = (deleteOption: { displayName: string; key: string }, event: any) => {
    const filteredOption = selectedOption.filter((option: any) => option?.key !== deleteOption?.key);
    setSelectedOption(filteredOption);
    event?.stopPropagation();
  };

  const displayBriefOption = (option: IDropDown) => {
    return (
      <>
        {option.displayName}
        <i onClick={(event: any) => crossIconHandler(option, event)} className="aeh-icon-outlined-close">
          {' '}
        </i>
      </>
    );
  };

  const displayExtendedOption = (option: IDropDown) => {
    return (
      <>
        <div className="option_name">{option.displayName}</div>
        <div className="helperText">{option?.helpText}</div>
      </>
    );
  };

  return (
    <div className="multi_select_controller">
      <MultiSelect
        label={label}
        value={selectedOption}
        onChange={onChange}
        options={options}
        placeholder="Select Location"
        required
        renderSearch={renderSearch}
        displayBriefOption={displayBriefOption}
        displayExtendedOption={displayExtendedOption}
      />
    </div>
  );
};
